export default __webpack_public_path__ + "static/media/up-arrow.59436641.svg";